import React from 'react';
import { TabPanel, TabPanels } from '@chakra-ui/react';
import GeneralPage from './GeneralPage';
import { useSession } from '../../../../context/SessionProvider';
import { useGetOneOrganisationSuspense } from '../../../../services/api/generated/client';
import { unwrapModel } from '../../../../services/api/unwrapModel';
const OrganisationProfile = () => {
    const user = useSession();
    const { data: response } = useGetOneOrganisationSuspense(user.service_provider_id);
    const organisation = unwrapModel(response);
    if (!organisation) {
        return null;
    }
    return (React.createElement(TabPanels, null,
        React.createElement(TabPanel, null,
            React.createElement(GeneralPage, { organisation: organisation }))));
};
export default OrganisationProfile;
